import {alpha, Divider, Theme} from "@mui/material";
import React, {FC} from "react";
import {useTheme} from "@mui/material/styles";
import {SxProps} from "@mui/system";

interface IProps {
    gradientPosition: "right" | "left" | "center"
    height: number
    sx?: SxProps<Theme>
}

const CustomDivider: FC<IProps> = (props) => {
    const theme = useTheme()
    const getBackground = () => {
        switch (props.gradientPosition) {
            case "center":
                return `linear-gradient(to right, ${alpha(theme.palette.primary.main, .05)}, ${alpha(theme.palette.primary.main, .7)}, ${alpha(theme.palette.primary.main, .05)})`
            case "right":
                return `linear-gradient(to right, ${alpha(theme.palette.primary.main, .05)}, ${alpha(theme.palette.primary.main, .7)})`
            default:
                return `linear-gradient(to right, ${alpha(theme.palette.primary.main, .7)}, ${alpha(theme.palette.primary.main, .05)})`
        }
    }
    return (
        <Divider sx={{
            ...props.sx,
            background: getBackground(),
            height: `${props.height}px`
        }}/>
    )
}

export default CustomDivider
